import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/App';

/**
 * Drop-in replacement for react-router <Link> that prefetches the target
 * event's detail payload after a short hover (desktop) or on first touch
 * (mobile), so the detail page opens with zero visible wait.
 *
 * The actual cache hit happens via the global axios.get SWR wrapper in
 * App.js — this component just fires the warm-up GET.
 */
const prefetchTimers = new Map();

const PrefetchLink = ({ eventId, to, className, children, ...rest }) => {
  const warm = () => {
    if (!eventId || prefetchTimers.has(eventId)) return;
    const timer = setTimeout(() => {
      prefetchTimers.delete(eventId);
      // Fire-and-forget — if the SWR cache already has a fresh copy, this
      // resolves instantly from cache and makes no network request.
      axios.get(`${API}/events/${eventId}`).catch(() => {});
    }, 150);
    prefetchTimers.set(eventId, timer);
  };
  const cancel = () => {
    const t = prefetchTimers.get(eventId);
    if (t) {
      clearTimeout(t);
      prefetchTimers.delete(eventId);
    }
  };
  return (
    <Link
      to={to}
      className={className}
      onMouseEnter={warm}
      onFocus={warm}
      onTouchStart={warm}
      onMouseLeave={cancel}
      onBlur={cancel}
      {...rest}
    >
      {children}
    </Link>
  );
};

export default PrefetchLink;
